export class CookieService {
    static getCookie(name) {
        // TODO: update cookies methods not from WG3
        // https://www.wrike.com/open.htm?id=522917906
        return WG.utils.getCookie(name);
    }
    static setCookie(name, value, options = {}) {
        WG.utils.setCookie(name, value, options);
    }
    static deleteCookie(name) {
        return WG.utils.deleteCookie(name);
    }
}



// WEBPACK FOOTER //
// ./node_modules/wg5/src/services/cookie.js